import { useState } from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import { downloadFileFromApi } from '~/helpers/dowloadFileFromApi';
import logger from '~/services/logger';
import { localeStore } from '~/mobx/localesStore';
import Calendar from '~/view/components/Calendar/Calendar';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import { promocodeLogStore } from '~/view/screens/PromocodeLogScreen/store/promocodeLogStore';

const PromocodeLogHeader = observer(() => {
  const [exporting, setExporting] = useState(false);

  const handleExportToXls = async () => {
    try {
      setExporting(true);
      await downloadFileFromApi('v3/promocodes/usage-log/export', { params: promocodeLogStore.paramsForLogsRequest });
    } catch (error: any) {
      logger.error({ error, place: 'PromocodeLogHeader exportPromocodeLogToXls', showModal: true });
    } finally {
      setExporting(false);
    }
  };

  const handleChangeDate = ({ startDate, endDate }: { startDate: Date | undefined; endDate: Date | undefined }) => {
    promocodeLogStore.setFilters({ startDate: moment(startDate).unix() * 1000, endDate: moment(endDate).unix() * 1000 });
  };

  return (
    <div className="d-flex justify-content-between mt-6 pr-4">
      <Calendar start_date={promocodeLogStore.filters.startDate} end_date={promocodeLogStore.filters.endDate} changeDate={handleChangeDate} />
      {promocodeLogStore.isDataNotPresented ? null : (
        <Button title={localeStore.t('export_to_excel')} onClick={handleExportToXls} loading={exporting} appearance="secondary" />
      )}
    </div>
  );
});

export default PromocodeLogHeader;
